module.exports = __webpack_public_path__ + "media/images/main/staffing-benefits/team-and-stiner-df99532d1f3fbbcee929c6b2cfcd2289.jpg";